import {ValueObject} from '@s-ui/domain'

import UserEntity from '../Entities/UserEntity'

export class BlockedUsersValueObject extends ValueObject {
  #items

  static create({items}) {
    return new BlockedUsersValueObject({
      items: items.map(user => new UserEntity({userId: user.userId, name: user.name}))
    })
  }

  constructor({items}) {
    super()
    this.#items = items
  }

  toJSON() {
    return {
      items: this.#items.map(userEntity => ({
        userId: userEntity.getId(),
        name: userEntity.getName()
      }))
    }
  }
}
